import { Schema, type } from "./index";


class MySchema extends Schema {
    @type("string") hello: string;
}


const state = new MySchema();
state.hello = "world";

console.log(state.encode());

